import React from 'react';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

type Props = {
  canCreateOneTimePaymentRequest: boolean;
  goToOneTimePaymentPage: (...args: Array<any>) => any;
};

class OneTimePaymentButton extends React.Component<Props> {
  render(): React.ReactNode {
    const { canCreateOneTimePaymentRequest, goToOneTimePaymentPage } = this.props;
    return (
      <Button
        type="primary"
        full
        className="floatRight"
        onClick={goToOneTimePaymentPage}
        disabled={!canCreateOneTimePaymentRequest}
      >
        Request payment
      </Button>
    );
  }
}
export default OneTimePaymentButton;
